import { api } from '@forbiz/web-kit'
import type { CardSkinListResponse } from '@forbiz/contracts'

/** 수신자 디지털 카드 스킨 (BIZ-86). 주문서 선택 UI용 — 활성 스킨만 온다. */
export const cardSkinsApi = {
  list: (occasionType: string) =>
    api.get<CardSkinListResponse>(`/api/card-skins?occasionType=${encodeURIComponent(occasionType)}`),
}
